export const selectClientError = ({ clientError }) => clientError.error
export const selectRTCConnectionTime = ({ clientError }) => clientError.rtcConnectionTime
export const selectRTCDisconnectionTime = ({ clientError }) => clientError.rtcDisconnectionTime
export const selectOnGoBackToPublic = ({ clientError }) => clientError.onGoBackToPublic
